import React from "react";
import { Dimensions, View } from "react-native";

const MOBILE_WIDTH = 420;
export const FoldableWrapper = ({ children }) => {
  const windowDimensions = Dimensions.get("window");
  const width = windowDimensions?.width ?? 0;
  const height = windowDimensions?.height ?? 0;

  const aspectRatio = height / width;
  const isFold = width > 600 && aspectRatio < 1.7 && width < 900;
  const contentWidth = isFold ? MOBILE_WIDTH : width;

  return (
    <>
      {isFold ? (
        <View
          style={{
            flex: 1,
            backgroundColor: "black",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <View style={{ width: contentWidth, flex: 1 }}>{children}</View>
        </View>
      ) : (
        <React.Fragment>{children}</React.Fragment>
      )}
    </>
  );
};

export const useIsFoldable = () => {
  const windowDimensions = Dimensions.get("window");
  const width = windowDimensions?.width ?? 0;
  const height = windowDimensions?.height ?? 0;

  const aspectRatio = height / width;
  const isFold = width > 600 && aspectRatio < 1.7 && width < 900;
  return { isFold, deviceWidth: isFold ? MOBILE_WIDTH : width };
};
